import { useTranslation } from "react-i18next";

export const LoginTop = () => {
  const { t } = useTranslation();

  return (
    <div className="login-top">
      <p className="login-mode-chip">{t("login")}</p>
      <h1 id="login-heading">{t("welcome_back")}</h1>
      <p className="login-subtitle">{t("sign_in_description")}</p>
    </div>
  );
};
